import { PacklinkContext } from './packlinkContext.js';
import { jsx } from '@emotion/react/jsx-runtime';

const PacklinkProvider = _ref => {
  let {
    children,
    application,
    cdnUrl
  } = _ref;
  return jsx(PacklinkContext.Provider, {
    value: {
      application,
      cdnUrl
    },
    children: children
  });
};

export { PacklinkProvider };
//# sourceMappingURL=packlinkProvider.js.map
